module.exports = __webpack_public_path__ + "img/logo-light.d3c74391.svg";